import { InjectionToken } from '@angular/core';
import { GrowthBook } from '@growthbook/growthbook';

export const GROWTHBOOK = new InjectionToken<GrowthBook>('GROWTHBOOK');
